import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'reactstrap';
import { ContainerBig, DescriptionData, DescriptionTitle } from './styled';

const PanelDetails = ({ data }) => (
    <ContainerBig>
        <Row>
            {
                data.map(({ content, title, visible = true }, index) => {
                    if (!visible) return null;
                    return (
                        <Col key={ index } md="4" xs="12">
                            <DescriptionTitle>{ title }: </DescriptionTitle>
                            <DescriptionData>{ content ? content : 'n/d' }</DescriptionData>
                        </Col>
                    );
                })
            }
        </Row>
    </ContainerBig>
);

PanelDetails.propTypes = {
    data: PropTypes.array
};

export default PanelDetails;
